import { Link } from 'react-router-dom';
import type { MVItem } from '@/mocks/mvs';

interface MVCardProps {
  mv: MVItem;
  size?: 'default' | 'large' | 'small';
}

export default function MVCard({ mv, size = 'default' }: MVCardProps) {
  const aspectClass = size === 'large' ? 'aspect-[16/9]' : size === 'small' ? 'aspect-[4/3]' : 'aspect-[16/9]';

  return (
    <Link
      to={`/article/${mv.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 hover:bg-background-100 transition-all duration-300"
      data-product-shop
    >
      <div className={`relative ${aspectClass} overflow-hidden`}>
        <img
          src={mv.coverImage}
          alt={`${mv.title} - ${mv.artist} MV封面`}
          title={`${mv.title} - ${mv.artist}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
            <i className="ri-play-fill text-2xl text-white ml-0.5"></i>
          </div>
        </div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md">
          {mv.duration}
        </div>
        <div className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-md font-medium">
          HD
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {mv.title}
        </h3>
        <p className="text-sm text-foreground-500 mt-1">{mv.artist}</p>
        <div className="flex items-center gap-3 mt-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {mv.views}
          </span>
          <span>{mv.releaseDate}</span>
        </div>
      </div>
    </Link>
  );
}